import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import {
  getDashboardDataSuccess,
  getDashboardDataFailure,
} from "../../Action/dashboard/getDashboardDataAction";
import { GET_DASHBOARD_DATA } from "../../Action/actionTypes";
import {
  notifyError,
} from "../../../Utils/Helper";


function* getDashboardDataRequest(action) {
  try {

    const { data } = yield API.get("/getdashboardData");

    if (data?.meta?.code === 200) {
      yield put(getDashboardDataSuccess(data?.data));
    
      if (action?.payload?.callback) {
        yield call(action.payload.callback, data);
      }
    } else {
      yield put(getDashboardDataFailure());
      notifyError("Invalid Request");
    }
  } catch (error) {
    yield put(getDashboardDataFailure());
    notifyError("Invalid Request");
  }
}

export function* watchGetDashboardDataAPI() {
  yield takeEvery(GET_DASHBOARD_DATA, getDashboardDataRequest);
}

export default function* rootSaga() {
  yield all([watchGetDashboardDataAPI()]);
}
